import { Wrench } from 'lucide-react';
import { useSiteMode } from '../../app/siteModeContext';
import { t } from '../../lib/copy';
import { CountdownTiles, describeRemaining } from './FlipTile';
import { SiteShell } from './SiteShell';
import { useCountdown } from './useCountdown';

function BackIn({ until }: { until: Date }) {
  const remaining = useCountdown(until);
  if (remaining.done) return null;
  return (
    <>
      <div className="mt-8 w-full max-w-md">
        <CountdownTiles remaining={remaining} />
      </div>
      <p className="mt-4 text-sm font-medium text-brand" aria-live="polite">
        {t('site.maintenance.until', { time: describeRemaining(remaining) })}
      </p>
    </>
  );
}

/** Maintenance mode (D32): optional custom message and "back in" countdown from Remote Config. */
export function MaintenancePage() {
  const { config } = useSiteMode();
  return (
    <SiteShell title="Maintenance">
      <span className="flex size-16 animate-breathe items-center justify-center rounded-full bg-sunrise-50 text-sunrise-700 shadow-card motion-reduce:animate-none">
        <Wrench className="size-8" aria-hidden />
      </span>
      <h1 className="mt-5 text-display font-bold text-ink">{t('site.maintenance.title')}</h1>
      <p className="mt-3 max-w-lg text-body text-slate">
        {config.maintenanceMessage || t('site.maintenance.body')}
      </p>
      {config.maintenanceUntil && <BackIn until={config.maintenanceUntil} />}
    </SiteShell>
  );
}
